module.exports = __webpack_public_path__ + "media/images/doctor_female-38e2b68707e553576f7fabc453d52aae.png";